import React from 'react'
import { makeStyles } from "@material-ui/core";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

export const TextWrap = ({ text, max, defaultText, placement }) => {
  if (!text) return <>{defaultText ? defaultText : ""}</>;
  let text_ = text;
  let pop = false;
  if (text.length > max) {
    text_ = text.substring(0, max) + "..";
    pop = true;
  }

  if (!placement) placement = "bottom";

  return (
    <>
      {pop && (
        <OverlayTrigger
          key={placement}
          placement={placement}
          style={{ zIndex: 100000 }}
          overlay={
            <Tooltip id={`tooltip-${placement}`} style={{ zIndex: 100000 }}>
              {text}
            </Tooltip>
          }
        >
          <span>{text_}</span>
        </OverlayTrigger>
      )}
      {!pop && <span>{text_}</span>}
    </>
  );
};
